<template>
  <div>
    <exp-header :items="this.$host.items"></exp-header>
    <div class="expense">
      <h2>{{title}}</h2>
      <div>
        <img src="../../../assets/images/image_cost.jpg" alt>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import ExpHeader from "./components/exp-header";
import Footer from "../footer/app-footer";

export default {
  name: "expense",
  data() {
    return {
      title: "费用说明"
    };
  },
  components: {
    ExpHeader,
    Footer
  }
};
</script>

<style lang="css" scoped>
.expense {
  padding-top: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.expense h2 {
  color: #313131;
  font-size: 24px;
  font-weight:600;
  padding: 60px 0 30px 0;
}
</style>